import { api } from './api';

/**
 * Preferences Service
 *
 * Manages user-level preferences (language, etc.).
 * No tenant header required — preferences are user-global.
 */
class PreferencesService {
  /**
   * Get the current user's preferences
   * @returns {Promise<{language: string, preferences: object}>}
   */
  async getPreferences(authToken) {
    try {
      const response = await api.get('/v1/user/preferences', {
        headers: {
          'Authorization': 'Bearer ' + authToken,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Preferences: Error fetching:', error);
      throw error;
    }
  }

  /**
   * Update user language preference
   * @param {string} language - One of: en, es, pt, fr, de
   * @returns {Promise<{success: boolean, language: string}>}
   */
  async updateLanguage(authToken, language) {
    try {
      const response = await api.put('/v1/user/preferences', { language }, {
        headers: {
          'Authorization': 'Bearer ' + authToken,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Preferences: Error updating language:', error);
      throw error;
    }
  }

  // Recording preferences are tenant-scoped (per-user, per-tenant); they require
  // the `tenant` header in addition to the auth bearer. REQ-09 of plan 81.
  async getRecordingPreferences(authToken, tenant) {
    const response = await api.get('/v1/user/preferences/recording', {
      headers: {
        'Authorization': 'Bearer ' + authToken,
        'tenant': tenant,
      },
    });
    return response.data;
  }

  async updateRecordingPreferences(authToken, tenant, scrollSpeed) {
    const response = await api.put('/v1/user/preferences/recording', { scroll_speed: scrollSpeed }, {
      headers: {
        'Authorization': 'Bearer ' + authToken,
        'tenant': tenant,
      },
    });
    return response.data;
  }
}

export const preferencesService = new PreferencesService();
